import { render, staticRenderFns } from "./ApisRoutes.vue?vue&type=template&id=483d610f&"
import script from "./ApisRoutes.vue?vue&type=script&lang=js&"
export * from "./ApisRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports